"use client"

import { use } from "react"
import { setSubscribeModalShown } from "util/cookies"

/**
 * Helper client component which sets the subscribe-modal-shown cookie.
 *
 * This cookie is used to show (or not show) the full-page subscribe modal.
 */
export default function ClientCookies(props: {
  params: Promise<{ blogSlug: string }>
}) {
  const params = use(props.params)
  if (params.blogSlug) {
    // Necessary to decode the blogSlug because it is encoded in the URL.
    let decodedBlogSlug = decodeURIComponent(params.blogSlug)
    setSubscribeModalShown(decodedBlogSlug)
  }
  return null
}
